import React from 'react';
import './employeestext.css';
import aboutContent from '../../../content/pages/about.json';

function EmployeesText() {
    const { heading, description } = aboutContent.employeesSection;

    return (
        <section className='employees-header-text'>
            <h2>{heading}</h2>
            <p>{description}</p>
        </section>
    );
}

export default EmployeesText;
